import { render, staticRenderFns } from "./HrReviewsNews.vue?vue&type=template&id=2e84dca4"
import script from "./HrReviewsNews.vue?vue&type=script&lang=js"
export * from "./HrReviewsNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports